import {HTTP} from '@/CallAPI'

export default{
  forgotPwd (data) {
    return HTTP.post('forgot-pwd', data)
  },
  resetPwd (data) {
    return HTTP.post('reset-pwd', data)
  }
}



// WEBPACK FOOTER //
// ./src/service/forgot-password.js